module.exports = __webpack_public_path__ + "static/img/green_building.7f7b6a21.png";